import { render, staticRenderFns } from "./TablaDetallesDePagos.vue?vue&type=template&id=782e1ef6&scoped=true&"
import script from "./TablaDetallesDePagos.vue?vue&type=script&lang=js&"
export * from "./TablaDetallesDePagos.vue?vue&type=script&lang=js&"
import style0 from "./TablaDetallesDePagos.vue?vue&type=style&index=0&id=782e1ef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782e1ef6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VTooltip,
})
